/********************************************************************************
 * Copyright (c) 2019-2020 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { createContext } from 'react';
// We don't include `undefined` as context value to avoid checking the value in all components
export const MainContext = createContext(undefined);
//# sourceMappingURL=context.js.map